export const useStringToArray = (item) => {
  if (item) {
    return Array.isArray(item) ? item[0] : item;
  }
  return null;
};
